export const CONTAINER_TEST_ID = 'offer-alert';

export const CONTAINER_STATE = {
  LOADING: 'loading',
  ERROR: 'error',
  READY: 'ready'
};
